import Vouchers from '../../../../store/vouchers/main';

angular
    .module('festzelt-os.vouchers.main')
    .factory('Vouchers', [
        '$injector',
        'Voucher',
        ($injector, Voucher) => new Vouchers(Voucher, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/store/vouchers.js